// Helper function to get environment data for all events
export const getEnvironmentData = () => {
  return {
    environment: import.meta.env.VITE_PUBLIC_APP_ENV || 'development',
    timestamp: new Date().toISOString()
  };
}; 